<app-alert></app-alert>
<form [formGroup]="uploadFormFile" (ngSubmit)="onSubmit()" class="container mt-6">
  <div class="form-header">
    <h1>{{ 'global.support-file-category-management' | translate }}</h1>
  </div>

  <div formArrayName="rows">
    @for (row of rows.controls; track $index) {
      <div [formGroupName]="$index" class="inputs-group">
        @for (lang of languages; track lang.code) {
          <img
            class="flag"
            [src]="'./../../../../../assets/images/support-page/flags/' + lang.flag"
            [alt]="lang.label" />
          <div class="input-wrapper">
            <input
              type="text"
              class="form-control"
              [formControlName]="lang.code"
              placeholder="{{ 'global.support-file-name' | translate }}" />
          </div>
        }
        <button type="button" class="remove-row-btn" (click)="removeRow($index)">✖</button>
      </div>
    }
  </div>

  <button type="button" class="buttons--btn-add" (click)="addRow()">
    <i class="agres-plus"></i>
    {{ 'global.to-add' | translate }}
  </button>

  <div class="buttons mt-5">
    <button class="buttons--btn-cancel" type="button" (click)="closeDialog()">
      <i class="agres-close"></i>
      {{ 'global.cancel' | translate }}
    </button>
    <button
      class="buttons--btn-save"
      type="submit"
      [disabled]="uploadFormFile.invalid || loadError"
      [ngClass]="{ 'btn-disabled': uploadFormFile.invalid || loadError }">
      <i class="agres-upload"></i>
      {{ 'global.save' | translate }}
    </button>
  </div>
</form>
